/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { dimensionStyle } from './themes/PieChartStyles.css';
import { TrackResizeContainer } from '../PRIVATE_TrackResizeContainer';
import { PieChartWithDimensions } from './PieChartWithDimensions';
import type { PieChartProps } from './pieChart.types';

/**
 * Pie charts are useful for visualizing parts of a whole, but do not display zero or negative values so they are not recommended for data sets that may have negative or null data
 */
export function PieChart({ width, height, ...props }: PieChartProps) {
  return (
    <TrackResizeContainer width={width} height={height} class={dimensionStyle}>
      {(width, height) => <PieChartWithDimensions width={width} height={height} {...props} />}
    </TrackResizeContainer>
  );
}
